/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import Vue2Editor from "vue2-editor";
import { createPinia, PiniaVuePlugin } from 'pinia'
import VueCompositionAPI from '@vue/composition-api'
import './assets/js/filter';

Vue.use(VueCompositionAPI)
Vue.use(PiniaVuePlugin)
const pinia = createPinia()
Vue.use(pinia);

export const EventBus = new Vue();

// router setup
import router from './routes/router';
import { useConfigStore } from './stores/configStore';
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(Vue2Editor);

// Initialize app code
useConfigStore().fetchAndSetAppCode();

Vue.config.productionTip = false;
/* eslint-disable no-new */

new Vue({
  pinia,
  el: '#app',
  render: h => h(App),
  router
});
